jQuery(document).ready(function($) {
  var controller = new ScrollMagic.Controller();
  var scenesArray = [];

  if($('.wf-image-text').length) {
    scenesArray.push(new ScrollMagic.Scene({
      triggerElement: '.wf-image-text'
    })
    .setClassToggle('.wf-image-text', 'show')
    .reverse(false)
    // .addIndicators()
    .addTo(controller)
    );
  }
});
